import React from 'react';

const FacebookLogo = () => {
    return (
        <svg width={15} height={31} viewBox="0 0 15 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.6931 8.65911H9.36075V7.19604C9.36075 5.71877 9.95734 4.85229 11.7329 4.85229C12.4573 4.85229 13.196 5.00854 13.6789 5.16479L14.7443 0.61934C13.9914 0.392067 12.3295 0.0227475 10.4687 0.0227475C6.36359 0.0227475 3.30961 2.33809 3.30961 7.08241V8.65911H0.227228V13.2046H3.30961V30.4773H9.36075V13.2046H13.6931V8.65911Z" fill="#3B5999" />
        </svg>
    );
}

export default FacebookLogo;